import { instanceOf, node, string } from "prop-types";
import React from "react";
import PinchZoomPan from "shared/components/configurator/PinchZoomPan";
import ImagePreloader from "shared/components/configurator/ImagePreloader";

export default class RemoteImage extends React.PureComponent {
  static propTypes = {
    imageURL: string,
    children: node,
    prefetchImageURLs: instanceOf(Set)
  };

  render() {
    const { imageURL, children, prefetchImageURLs } = this.props;

    return (
      <ImagePreloader imageURL={imageURL} prefetchImageURLs={prefetchImageURLs}>
        {image => (
          <PinchZoomPan
            renderContent={(x, y, scale) => (
              <img
                src={image}
                className="configurator"
                style={{
                  transformOrigin: "0 0",
                  // Image is scaled to 300% in css to fix blurry images after translate3d on iPad
                  transform: `translate3d(${x}px, ${y}px, 0) scale(${scale /
                    3})`
                }}
              />
            )}
          >
            {children}
          </PinchZoomPan>
        )}
      </ImagePreloader>
    );
  }
}
